/**
 * Generate an array of page numbers with total page count
 * @param start first page number
 * @param end last page number
 * @returns array of page numbers
 */
function range(start: number, end: number): number[] {
  const length = end - start + 1;
  return Array.from({ length }, (_, i) => i + start);
};

export default range;
